import { PanelType } from '../../../../../../panels/types';
import { CriteriaPanelData } from '../../base-criteria-plugin-panel/ConnectedBaseCriteriaPanel';

export const meddicPanelType: PanelType<CriteriaPanelData> = {
  name: 'MEDDIC_PANEL',
  location: 'left',
};
